module.exports = __webpack_public_path__ + "static/img/jrzh.fe4824b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrzh.jpg
// module id = SMox
// module chunks = 0